/**
 * Financial Snapshot API endpoint config.
 * Guid scoping + api-internal slot confirmed via Internal API smoke-test (OQ-1 / DEP-1).
 */
export const FINANCIAL_SNAPSHOT_API_CONFIG = {
  /** Key into `environment.apiEndpoints`. */
  apiName: 'api-internal' as const,
  /** Path prefix for FS routes. */
  pathPrefix: '/financialsnapshot',
  /**
   * How the selected client guid is scoped on GET.
   * `'query'` → `/financialsnapshot?guid=…`; POST/PATCH carry guid in the body.
   */
  guidScope: 'query' as 'path' | 'query' | 'header',
} as const;

export type FinancialSnapshotApiConfig = typeof FINANCIAL_SNAPSHOT_API_CONFIG;
